import React from "react";
import styled from "styled-components";
import {
  Elevation,
  FontWeight,
  GlossyThemeProvider,
  Radius,
  Spacing,
  background,
  content,
  cover,
  dominant,
  form,
  transparentize,
} from "@glossy";
import { aiTextGradient } from "@glossy/mixins";
import Illustration from "@radarly/components/cards/card-edition/illustration";
import { IProps as IllustrationProps } from "@radarly/components/cards/card-edition/illustration";
import { Dataviz, DatavizName } from "@radarly/models/dataviz";

export interface IProps {
  viz: Dataviz["name"];
  title: string;
  selected?: boolean;
  onClick: () => void;
  color: IllustrationProps["colorScheme"];
  vizOptions: object;
}

const Root = styled.div<{ selected: boolean }>`
  position: relative;
  width: 182px;
  height: 122px;
  border-radius: ${Radius.Medium};
  box-shadow: ${Elevation.Elevation_1};
  padding: ${Spacing.Medium};
  color: ${content};
  background-color: ${background};
  overflow: hidden;
  cursor: pointer;
  :after {
    content: "";
    ${cover()};
    border-radius: inherit;
    border: ${(props) => props.selected && `2px solid ${dominant(props)}`};
  }
  :hover:after {
    background-color: ${(props) => transparentize(0.8, form(props, "primary"))};
  }
`;

const Viz = styled.div`
  height: 48px;
`;

const Title = styled.div`
  font-weight: ${FontWeight.Normal};
  color: ${form};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${Spacing.Medium};
  height: 38px;
  word-break: break-word;
  > * {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const AISpan = styled.span`
  ${aiTextGradient()};
`;

const PanelsCardLibraryCard = ({
  viz,
  title,
  selected,
  onClick,
  color = "default",
  vizOptions = {},
}: IProps) => (
  <GlossyThemeProvider name="tile">
    <Root selected={selected} onClick={onClick}>
      <Viz>
        <Illustration
          datavizName={viz}
          colorScheme={color}
          options={vizOptions}
        />
      </Viz>
      <Title>
        {viz === DatavizName.AI ? (
          <AISpan>{title}</AISpan>
        ) : (
          <span>{title}</span>
        )}
      </Title>
    </Root>
  </GlossyThemeProvider>
);

export default PanelsCardLibraryCard;
